import { render, staticRenderFns } from "./EmployeeRequestEdit.vue?vue&type=template&id=04b90f0a&scoped=true"
import script from "./EmployeeRequestEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeRequestEdit.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRequestEdit.vue?vue&type=style&index=0&id=04b90f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b90f0a",
  null
  
)

export default component.exports